import React, { Component } from "react";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { bindActionCreators } from "redux";
import moment from "moment";
import _ from "lodash";
import {
	TextField,
	SelectField as RFSelectField
} from "redux-form-material-ui";
import { Card, CardText } from "material-ui/Card";
import { connect } from "react-redux";
import { RaisedButton, FlatButton, MenuItem } from "material-ui";
import {
	actionCreateSupportTicket,
	actionUpdateSupportTicket,
	actionGetUsersSupportList
} from "../../actions/SupportTicketActions";
import { required } from "../../common/validaciones";
import {
	MODE_CRU_CREATE,
	MODE_CRU_UPDATE,
	MODE_CRU_SHOW
} from "../../actions/ActionConstants";
import {
	ROL_EMPRESA,
	ROL_SOPORTE,
	ESTADO_SUPPORT_TICKET_ENVIADO,
	ESTADO_SUPPORT_TICKET_EN_PROCESO,
	ESTADO_SUPPORT_TICKET_RESUELTO,
	ESTADO_SUPPORT_TICKET_CANCELADO
} from "../../common/Constants";
import { SUPPORT_TICKET } from "../../config/RoutesConstants";
import Util, { SUCCESS, ERROR, handleSubmitFail } from "../../common/Util";
import UtilPC from "../../common/UtilPC";
import VerticalListFields from "../../components/VerticalListFields/VerticalListFields";
import ImageSelector from "../../components/ImageSelector/ImageSelector";
import { actionUploadFile } from "../../actions/MediaActions";
import "./SupportTicket.css";
let _handleSubmitFail;

class SupportTicketForm extends Component {
	constructor(props) {
		super(props);
		let state =
			this.props.modeCRU === MODE_CRU_SHOW
				? this.returnStateShowSupportTicket()
				: {};
		this.state = state;
		this.initializeValues = this.initializeValues.bind(this);
		this.returnOnSubmit = this.returnOnSubmit.bind(this);
		_handleSubmitFail = handleSubmitFail.bind(this);
		this.renderSelectFieldUsersSupport = this.renderSelectFieldUsersSupport.bind(
			this
		);
	}

	componentWillMount() {
		if (!this.props.modeCRU || this.props.rol === ROL_EMPRESA) {
			this.props.history.push(SUPPORT_TICKET);
		} else {
			if (!this.props.usersSupportList) this.props.actionGetUsersSupportList();
			if (this.props.modeCRU === MODE_CRU_CREATE) this.initializeValues(false);
			else {
				if (
					this.props.modeCRU === MODE_CRU_UPDATE ||
					this.props.modeCRU === MODE_CRU_SHOW
				) {
					this.initializeValues(true);
				}
			}
		}
	}

	returnStateShowSupportTicket() {
		const state = {
			enableField: true
		};
		return state;
	}

	initializeValues(flag) {
		if (flag) {
			this.setState({
				title: "Modificar Tiquet",
				subTitle: "Edite Tiquet"
			});
			const { date, idUserDestination } = this.props.supportTicket;
			this.props.initialize({
				...this.props.supportTicket,
				date: Util.formatDateToShowNotHour(date),
				idUserDestination: "" + idUserDestination
			});
		} else {
			this.setState({
				title: "Alta Tiquet De Soporte",
				subTitle: "Agrege un Tiquet De Soporte"
			});
			this.props.initialize({
				status: "",
				date: Util.formatDateToShowNotHour(new Date()),
				emailUserOrigin: this.props.email
			});
		}
	}

	onSubmit(formValues) {
		formValues.date = moment().format("YYYY-MM-DD");
		this.setState({ formValues });
		if (
			formValues.photoUrl !== null &&
			typeof formValues.photoUrl === "object"
		) {
			let path = "supportTicket/img";
			let type = "image";
			this.props.actionUploadFile(
				formValues.photoUrl,
				path,
				type,
				this.props.firebaseToken,
				this.returnUploadFile.bind(this)
			);
		} else this.createOrUpdateSupportTicket(formValues);
	}
	returnUploadFile(url, path) {
		const values = this.state.formValues;
		values.photoUrl = url;
		values.photoPath = path;
		this.createOrUpdateSupportTicket(values);
	}
	createOrUpdateSupportTicket(values) {
		if (this.props.modeCRU === MODE_CRU_CREATE) {
			this.props.actionCreateSupportTicket(values, this.returnOnSubmit);
		} else if (this.props.modeCRU === MODE_CRU_UPDATE) {
			this.props.actionUpdateSupportTicket(
				this.props.supportTicket.id,
				values,
				this.returnOnSubmit
			);
		}
	}
	returnOnSubmit(response) {
		if (this.props.modeCRU === MODE_CRU_CREATE) {
			if (response === SUCCESS) {
				Util.showNoty(SUCCESS, "Tiquet de soporte creado");
				this.props.history.push(SUPPORT_TICKET);
			} else if (response === ERROR)
				Util.showNoty(ERROR, "Error al crear Tiquet de soporte");
		} else if (this.props.modeCRU === MODE_CRU_UPDATE) {
			if (response === SUCCESS) {
				Util.showNoty(SUCCESS, "Tiquet de soporte Modificado");
				this.props.history.push(SUPPORT_TICKET);
			} else if (response === ERROR)
				Util.showNoty(ERROR, "Error al modificar Tiquet de soporte");
		}
	}
	renderSelectFieldUsersSupport(list) {
		return _.map(list, (user, i) => {
			return (
				<MenuItem key={user.id} value={user.id} primaryText={user.email} />
			);
		});
	}
	render() {
		const { handleSubmit } = this.props;
		return (
			<div className="center">
				<Card className="card">
					{UtilPC.renderCardTitleCRU(this.props.modeCRU, "Tiquet de Soporte")}
					<CardText>
						<form>
							<div className="content-papercard">
								<VerticalListFields
									titleText="Datos Del Tiquet"
									titleClass="title-papercard-primary"
									paperClass="papercard top20"
									contentClass="content-papercard-around"
								>
									<div className="rows-column-simple bottom25">
										<div className="columns-row-between">
											<Field
												name="emailUserOrigin"
												component={TextField}
												floatingLabelText="Origen"
												validate={[required]}
												fullWidth
												floatingLabelFixed={false}
												disabled={true}
											/>
											<Field
												name="idUserDestination"
												component={RFSelectField}
												floatingLabelText="Usuario De Destino"
												fullWidth
												className="left20"
												validate={[required]}
												disabled={
													this.props.modeCRU === MODE_CRU_CREATE ? false : true
												}
											>
												{this.renderSelectFieldUsersSupport(
													this.props.usersSupportList
												)}
											</Field>
										</div>
										<div className="columns-row-between">
											<Field
												name="status"
												component={RFSelectField}
												floatingLabelText="Estado"
												disabled={
													this.props.modeCRU === MODE_CRU_UPDATE ? false : true
												}
												fullWidth
											>
												<MenuItem
													key={1}
													value={ESTADO_SUPPORT_TICKET_ENVIADO}
													primaryText={ESTADO_SUPPORT_TICKET_ENVIADO}
													disabled={true}
												/>
												<MenuItem
													key={2}
													value={ESTADO_SUPPORT_TICKET_EN_PROCESO}
													primaryText={ESTADO_SUPPORT_TICKET_EN_PROCESO}
													disabled={
														this.props.rol === ROL_SOPORTE &&
														this.props.modeCRU === MODE_CRU_UPDATE
															? false
															: true
													}
												/>
												<MenuItem
													key={3}
													value={ESTADO_SUPPORT_TICKET_RESUELTO}
													primaryText={ESTADO_SUPPORT_TICKET_RESUELTO}
													disabled={
														this.props.rol === ROL_SOPORTE &&
														this.props.modeCRU === MODE_CRU_UPDATE
															? false
															: true
													}
												/>
												<MenuItem
													key={4}
													value={ESTADO_SUPPORT_TICKET_CANCELADO}
													primaryText={ESTADO_SUPPORT_TICKET_CANCELADO}
												/>
											</Field>
											<Field
												name="date"
												component={TextField}
												floatingLabelText="Fecha"
												validate={[required]}
												fullWidth
												floatingLabelFixed={false}
												disabled={true}
												className="left20"
											/>
										</div>
										<div className="columns-row-between">
											<Field
												name="text"
												component={TextField}
												floatingLabelText="Describa su problema"
												floatingLabelFixed
												multiLine
												rows={5}
												fullWidth
												validate={required}
												disabled={
													this.props.modeCRU === MODE_CRU_SHOW ||
													this.props.rol === ROL_SOPORTE
														? true
														: false
												}
											/>
										</div>
										<div className="columns-row-between top20">
											<ImageSelector
												classNameIS={""}
												fieldName={"photoUrl"}
												label={"Seleccionar foto"}
												labelInfo={"La imagen debe ser JPG"}
												styleRenderPreviews={{ marginBottom: 45 }}
												styleButton={{ margin: 5, width: 300 }}
												imagePreviewUrl={
													this.props.modeCRU === MODE_CRU_UPDATE &&
													this.props.supportTicket.photoUrl
														? this.props.supportTicket.photoUrl
														: ""
												}
												disabledUploadPhoto={
													this.props.modeCRU === MODE_CRU_SHOW ||
													this.props.rol === ROL_SOPORTE
														? true
														: false
												}
												fileSize={5000000}
											/>
										</div>
									</div>
								</VerticalListFields>
								{this.props.modeCRU !== MODE_CRU_CREATE ? (
									<VerticalListFields
										titleText="Respuesta Del Soporte"
										titleClass="title-papercard-primary"
										paperClass="papercard top20"
										contentClass="content-papercard-around"
									>
										<div className="rows-column-simple bottom25">
											<div className="columns-row-between">
												<Field
													name="answerText"
													component={TextField}
													floatingLabelText="Escriba una Respuesta"
													floatingLabelFixed
													multiLine
													rows={5}
													fullWidth
													disabled={
														this.props.modeCRU === MODE_CRU_SHOW ||
														this.props.rol !== ROL_SOPORTE
															? true
															: false
													}
												/>
											</div>
										</div>
									</VerticalListFields>
								) : null}
							</div>
							<div className="top20 text-right">
								<FlatButton
									label="Cancelar"
									onClick={() => this.props.history.push(SUPPORT_TICKET)}
									style={{ margin: 5 }}
								/>
								{this.props.modeCRU !== MODE_CRU_SHOW ? (
									<RaisedButton
										label="Aceptar"
										disabled={this.state.cantSubmit}
										primary
										style={{ margin: 5 }}
										onClick={handleSubmit(this.onSubmit.bind(this))}
									/>
								) : null}
							</div>
						</form>
					</CardText>
				</Card>
			</div>
		);
	}
}

function mapStateToProps(store) {
	const selector = formValueSelector("SupportTicketForm");
	return {
		formValues: selector(store, "idUserDestination", "text"),
		supportTicket: store.supportTicket.supportTicket,
		usersSupportList: store.supportTicket.usersSupportList,
		modeCRU: store.supportTicket.modeCRU,
		rol: store.app.rol,
		email: store.app.username,
		firebaseToken: store.app.firebaseToken
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionCreateSupportTicket,
			actionUpdateSupportTicket,
			actionGetUsersSupportList,
			actionUploadFile
		},
		dispatch
	);
}

export default reduxForm({
	form: "SupportTicketForm",
	onSubmitFail: errors => _handleSubmitFail(errors)
})(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(SupportTicketForm)
);



// WEBPACK FOOTER //
// ./src/screens/SupportTicket/SupportTicketForm.js